<template>
  <div class="stores">
    <section-header tag="h1" class="mt-5 mb-5" title="門市資訊" subtitle="Stores"/>
    <section class="border-top border-dark mt-5 pt-4 pb-4">
      <div class="row">
        <div class="col-auto title">Loft29 Collection 於台北市共設立三家實體門市，均位於忠孝復興捷運站附近，分別為以義大利、西班牙等歐洲設計家具品牌為主的「形象門市」、來自丹麥、瑞典的北歐品牌「北歐設計門市」，以及主要展示日本家具品牌 Karimoku的「概念門市」</div>
      </div>
    </section>
    <section class="border-top border-dark mt-5 pt-4 pb-4">
      <div class="row">
        <div class="col-auto title mb-5">Loft29 Showroom 形象門市</div>
        <div class="col">
          <div class="d-md-flex justify-content-end">
            <span class="prefix text-secondary pe-3">T</span>
            <span class="info">(02)8771 3329</span>
          </div>
          <div class="mt-3 d-md-flex justify-content-end">
            <span class="prefix text-secondary pe-3">A</span>
            <span class="info">台北市大安區仁愛路三段123巷11-2號</span>
            <a href="https://maps.app.goo.gl/rzpmQTUPkSx5drQaA" target="_blank">
              <img class="icon" src="@/assets/img/google-maps.png" alt="map-1" title="GoogleMap">
            </a>
          </div>
          <div class="mt-3 d-md-flex justify-content-end">
            <span class="info">平日 11：00～19：00</span>
          </div>
          <div class="mt-3 d-md-flex justify-content-end">
            <span class="info">週六 13：00～18：00</span>
          </div>
          <div class="mt-3 d-md-flex justify-content-end">
            <span class="prefix text-secondary pe-3"></span>
            <span class="info">（週日公休）</span>
          </div>
        </div>
      </div>
    </section>
    <section class="border-top border-dark mt-5 pt-4 pb-4">
      <div class="row">
        <div class="col-auto title mb-5">Loft29 Concept store 概念門市</div>
        <div class="col">
          <div class="d-md-flex justify-content-end">
            <span class="prefix text-secondary pe-3">T</span>
            <span class="info">(02)2773 0129</span>
          </div>
          <div class="mt-3 d-md-flex justify-content-end">
            <span class="prefix text-secondary pe-3">A</span>
            <span class="info">台北市大安區忠孝東路三段248巷13弄20號</span>
            <a href="https://maps.app.goo.gl/DcdgNB9FTJACMQ7K6" target="_blank">
              <img class="icon" src="@/assets/img/google-maps.png" alt="map-2" title="GoogleMap">
            </a>
          </div>
          <div class="mt-3 d-md-flex justify-content-end">
            <span class="info">平日 11：00～19：00</span>
          </div>
          <div class="mt-3 d-md-flex justify-content-end">
            <span class="info">週六 13：00～18：00</span>
          </div>
          <div class="mt-3 d-md-flex justify-content-end">
            <span class="prefix text-secondary pe-3"></span>
            <span class="info">（週日公休）</span>
          </div>
        </div>
      </div>
    </section>
    <section class="border-top border-dark mt-5 pt-4 pb-4">
      <div class="row">
        <div class="col-auto title mb-5">Loft29 ScandiHome 北歐設計門市</div>
        <div class="col">
          <div class="d-md-flex justify-content-end">
            <span class="prefix text-secondary pe-3">T</span>
            <span class="info">(02)2772 0129</span>
          </div>
          <div class="mt-3 d-md-flex justify-content-end">
            <span class="prefix text-secondary pe-3">A</span>
            <span class="info">台北市大安區忠孝東路三段248巷13弄5號</span>
            <a href="https://maps.app.goo.gl/6JB3rHudE4ugG9uF8" target="_blank">
              <img class="icon" src="@/assets/img/google-maps.png" alt="map-2" title="GoogleMap">
            </a>
          </div>
          <div class="mt-3 d-md-flex justify-content-end">
            <span class="info">平日 11：00～19：00</span>
          </div>
          <div class="mt-3 d-md-flex justify-content-end">
            <span class="info">週六 13：00～18：00</span>
          </div>
          <div class="mt-3 d-md-flex justify-content-end">
            <span class="prefix text-secondary pe-3"></span>
            <span class="info">（週日公休）</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import SectionHeader from '@/components/SectionHeader.vue'
export default {
  name: 'Stores',
  components: {
    SectionHeader
  }
}
</script>

<style scoped>
.title {
  font-size: 19px;
  font-weight: 400;
  /* font-family: 'Noto Serif TC', serif; */
}
.info {
  font-size: 19px;
  font-weight: 400;
  /* font-family: 'Noto Serif TC', serif; */
  border-bottom: lightgray 1px solid;
}
.prefix {
  font-size: 1.3rem;
  /* font-family: 'Noto Serif TC', serif; */
}
.icon {
  width: 20px;
}
</style>
